<template>
<div>
    
    <p
        v-if="!show_help"
    >
        <a 
            v-on:click="show_help = true"
        >
            How do message patterns work?
        </a>
    </p>
    <p
        v-else
    >
        <b>How do message patterns work?</b>
    </p>
    <div
        v-if="show_help"
    >
        <p>Message patterns contain variables inside of curly braces.  For exampe <code>{first-name}</code> will be replaced with the recipient's first name.</p>
        <p>Sometimes, a variable will not have a value.  For example, if we attempt to send a message to someone where RedChirp does not know the recipient's first name, it will not be possible to replace the <code>{first-name}</code> variable with the recipients first name.  When a variable is missing, RedChirp will try to use the next message pattern.  So, by providing multiple message pattern(s) you can provide an alternate message for those occasions where a variable is missing.</p>
        <p>You can test your message patterns for the presence or absence of variables using the chips below.  When a chip looks like this:</p>
        <p><v-chip class="chip_on" close>{first-name}</v-chip></p>
        <p>It means that the variable is present.  For example, the above chip means that the <code>{first-name}</code> variable has a value.  Clicking on a green chip will turn it gray:</p>
        <p><v-chip class="chip_off">{first-name}</v-chip></p>
        <p>Which means that the variable is not present.</p>
    </div>

    <p><b>Message Pattern(s)</b></p>

    <v-textarea
        v-for="(item, index) in value_pretty"
        :key="index"
        :value="item"
        v-on:input="onInput(index,$event)"
        rows="1"
        auto-grow
        
    >
        <span 
             slot="append-outer"
        >
            <v-menu 
                bottom 
                offset-y  
            >

                <template v-slot:activator="{ on }">
                    
                    <div
                        style="min-width: 55px"
                    >
                        <v-icon
                            v-on:click="onClickEmoji($event, item, index)"
                        >
                            mdi-emoticon-outline
                        </v-icon>

                        <v-icon 
                            size="25"
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </div>   

                    
                </template>

                <v-list>
                    <v-list-item 
                        :disabled="index == 0"
                         v-on:click="onClickMoveUp(index)"
                    >
                        <v-list-item-title>Move Up</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :disabled="index == value_pretty.length -1"
                        v-on:click="onClickMoveDown(index)"
                    >
                        <v-list-item-title>Move Down</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="onClickDelete(index)"
                    >
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu> 
        </span>
    </v-textarea>

    <div
        style="text-align: right"
    >
        <v-btn
            v-on:click="onClickVariables"
            style="margin-right: 15px;"
        >
            Variables...
        </v-btn>

        <v-btn
            v-on:click="onClickAddPattern"
        >
            Add
        </v-btn>
    </div>

    <b>Test your message:</b>

    <!--<v-checkbox
        v-for="(item, index) in variables"
        :key="'cb'+index"
        :label="'{'+item.name+'}'"
        :value="item.name"
        v-model="enabled_variables"
        style="margin-bottom: -25px;"
    >
    </v-checkbox>-->

    <div
        style="margin-top: 15px; margin-bottom: -15px"
    >
    <v-chip
        v-for="(item, index) in variables"
        :key="'cb_chip_'+index"
        :class="{'chip_on': enabled_variables.includes(item.name), 'chip_off': !enabled_variables.includes(item.name)}"
        :close="enabled_variables.includes(item.name)"
        v-on:click="onClickVariableChip(item)"
        v-on:click:close="onClickVariableChip(item)"
    >
        {{'{'+item.name+'}'}}
    </v-chip>
    </div>

  


    <v-textarea
        style="margin-top: 25px;"
        label="Example Message"
        :value="example_message"
        readonly
        rows="1"
        auto-grow
    >
         <span 
             slot="append-outer"
        >
            <v-icon 
                size="25"
                v-on:click="example_index++; updateExampleMessage()"
            >
                mdi-refresh
            </v-icon>
         </span>
    </v-textarea>

    {{example_sms_message}}

    <m-edit-message-patterns-variable-dialog
        ref="variables-dialog"
        :context="context"
        :bulk_message_id="bulk_message_id"
    />

    

</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        context: {
            type: String,
            default: function() { return 'manually-sent'; }
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        always_mms: {
            type: Boolean,
            default: function() { return false; }
        },

        bulk_message_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            variables: [],
            enabled_variables: [],
            example_message: null,
            example_index: 0,
            picker_style: null,
            show_help: false,
        }
    },

    mounted () {
        this.update(true);
    },

    methods: {
        update(set_enabled_vars)
        {
            if ( this.context == null ) return;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/message-patterns/variables',
            
                'params' : {
                        'context': this.context,
                        'bulk_message_id': this.bulk_message_id,
                    },
            
                'on_success': (data) => {
                        this.variables = data.results;

                        if ( set_enabled_vars )
                        {
                            let ev = [];

                            for ( let i = 0; i < this.variables.length; i++ )
                            {
                                ev.push(this.variables[i].name);
                            }

                            this.enabled_variables = ev;
                        }
                    },
            
                'on_error': 'Unable to complete API call: could not get message patterns for context: '+this.context,
            });
        },

        onClickVariableChip(item)
        {
            let found = false;
            let ret = [];

            for ( let i = 0; i < this.enabled_variables.length; i++ )
            {
                if( this.enabled_variables[i] == item.name )
                {
                    found = true;
                    continue;
                }

                ret.push(this.enabled_variables[i]);
            }

            if ( !found )
                ret.push(item.name);

            this.enabled_variables =  ret;
        },

        updateExampleMessage()
        {
            let params = {
                'context' : this.context,
                'patterns' : this.value,
                'enabled_variables' : this.enabled_variables,
                'index' : this.example_index,
                'bulk_message_id': this.bulk_message_id,
            };

            
            
            this.$rc.testMessagePatterns(
                params,
            
                (data) => {
                    if ( data.example_message == null )
                        data.example_message = 'Could not generate a message';

                    this.example_message = data.example_message;

                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onInput(index, text) 
        {
            let ret = _.cloneDeep(this.value_pretty);
            if ( ret == null ) ret = [];

            while(index >= ret.length)
                ret.push('');

            ret[index] = text;

            this.$emit('input', ret);
        },

        onClickAddPattern()
        {
            let ret = _.cloneDeep(this.value_pretty);
            if ( ret == null ) ret = [];
            ret.push('');

            this.$emit('input', ret);
        },

        onClickDelete(index)
        {
            let ret = _.cloneDeep(this.value_pretty);
            if ( ret == null ) ret = [];
            ret.splice(index,1);
            this.$emit('input', ret);
        },

        onClickMoveUp(index)
        {
            let ret = _.cloneDeep(this.value_pretty);
            if ( ret == null ) ret = [];
            
            let tmp = ret[index];
            ret[index] = ret[index-1];
            ret[index-1] = tmp;
            
            this.$emit('input', ret);
        },

        onClickMoveDown(index)
        {
            let ret = _.cloneDeep(this.value_pretty);
            if ( ret == null ) ret = [];
            
            let tmp = ret[index];
            ret[index] = ret[index+1];
            ret[index+1] = tmp;
            
            this.$emit('input', ret);
        },

        onClickVariables()
        {
            this.$refs['variables-dialog'].showDialog();
        },

        onClickEmoji(event, item, index)
        {
            this.$rc.simplePickEmoji(
                (value) => {
                    if ( item == null || item.trim().length == 0 ) { this.onInput(index, value); return; }
                    this.onInput(index, item + ' '+value);
                }
            );
        },
    },

    watch: {
        context(newValue, oldValue) {
            this.update();
        },

        enabled_variables(newValue, oldValue) {
            this.updateExampleMessage();
        },

        value(newValue, oldValue) {
            this.updateExampleMessage();
        },
    },

    computed: {
        value_pretty() {
            let value = this.value;
            if ( value == null ) return [''];
            if ( value.length == 0 ) return [''];
            return value;
        },

        example_sms_message() {
            let ex = this.example_message;
            if ( ex == null || ex == 'Could not generate a message' ) return '';

            return this.$rc.messageType(ex, this.always_mms);
        }
    },
}
</script>

<style lang="scss" scoped>
.chip_on,
.chip_off
{
    margin-right: 15px; 
    font-family: monospace; 
    margin-bottom: 15px;
}

.chip_on
{
    background-color: rgba(0,255,0,0.3) !important;
}

.chip_off
{
    background-color: rgba(0,0,0,0.3);
}
</style>